<template>
    <div>
        <div class="budinessFlow">
            <h2>◆&nbsp;&nbsp;业务流程</h2>
            <h3>1、 签约注册：</h3>
            <p>委托方与普拉托签订《普托邦会员采购协议》、《普托邦会员服务协议》及《普托邦会员提取拆借服务协议》，并在普拉托运营的“普托e享”专用系统注册账号，用于业务操作。</p>
            <h3>2、 平价采购：</h3>
            <p>委托方通过普拉托平价采购指定标准托盘，采购价款支付成功即认购完成。</p>
            <h3>3、 委托管理：</h3>
            <p>委托方把平价采购获得的指定标准托盘委托给普拉托统一运营、维护管理，并按合同约定向普拉托支付托管费；会员存续期内委托方可提取同款托盘自用，同时享有委托管理的托盘数量中未提取使用部分的共享收益。</p>
            <h3>4、 残值处置：</h3>
            <p>委托方可针对其持有并委托的托盘向普拉托提出残值回购申请，普拉托将按协议约定的残值回购率进行回购。</p>

            <h2>◆&nbsp;&nbsp;费用说明</h2>
            <h3>1、托管费</h3>
            <p>指普拉托受托管理托盘资产，并为委托方提供托盘托管、维护，登记、共享收益清算、残值转让服务而收取的管理服务费；托管费按年度收取，不足1年，按1年收取。</p>
            <h3>2、上门统一配送回收费</h3>
            <p>会员存续期内委托方要求普拉托提供上门配送回收服务的，在普拉托服务范围内，普拉托平台统一按约定收取上门配送回收物流服务费。</p>
            <h3>3、其他费用</h3>
            <p>委托方因设备提取业务产生的租赁相关费用，包括但不限于押金、租费、清洗费等。</p>

        </div>

    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.budinessFlow {
    border: 1px solid #ccc;
    padding: 20px 20px 160px 20px;
    h2 {
        margin: 20px 0;
    }
    h3{
        margin: 10px 0;
    }
    p{
        text-indent:1em
    }
}
</style>